import store from '@/store';
import i18n from '@/i18n';
import api from '../../../api/signworkflow';
import * as types from './types';


export default {

  getSignWorkflows(context, searchRequest) {
    store.dispatch('application/startLoading');
    return api.getSignWorkflows(searchRequest)
      .then((data) => {
        let newTotalPage = Math.ceil(data.count / searchRequest.limit);
        if (newTotalPage === 0) {
          newTotalPage = 1;
        }
        context.commit(types.LOAD_SIGNWORKFLOWS_SUCCESS,
          { signWorkflows: data.signWorkflows,
            totalPages: newTotalPage,
            totalElmts: data.count,
          });
        store.dispatch('application/finishLoading');
      })
      .catch(() => {
        context.commit(types.LOAD_ERROR);
        store.dispatch('application/finishLoading');
      });
  },

  getSignWorkflow(context, id) {
    store.dispatch('application/startLoading');
    return api.getSignWorkflow(id)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(store.dispatch('application/finishLoading'));
  },

  getSignWorkflowsByUser(context, params) {
    store.dispatch('application/startLoading');
    return api.getSignWorkflowsByUser(params)
      .then((data) => {
        const newTotalPage = Math.ceil(data.count / params.parameters.limit);
        context.commit(types.LOAD_SIGNWORKFLOWS_SUCCESS,
          {
            signWorkflows: data.signWorkflows,
            totalPages: newTotalPage,
            totalElmts: data.count,
          });
        store.dispatch('application/finishLoading');
      })
      .catch(() => {
        context.commit(types.LOAD_ERROR);
        store.dispatch('application/finishLoading');
      });
  },

  getSignatureUserCount(context, params) {
    store.dispatch('application/startLoading');
    return api.getSignWorkflowsByUser(params)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
      });
  },

  getTemplates(context, searchRequest) {
    store.dispatch('application/startLoading');
    return api.getTemplates(searchRequest)
      .then((data) => {
        context.commit(types.GET_TEMPLATE_SUCCESS, data);
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => {
        context.commit(types.GET_TEMPLATE_FAILED);
        store.dispatch('application/finishLoading');
      });
  },

  newSignWorkflowOld(context, signWorkflow) {
    store.dispatch('application/startLoading');
    return api.newSignWorkflow(signWorkflow).then(() => {
      store.dispatch('application/finishLoading');
    }).catch((error) => {
      console.log(error);
      store.dispatch('application/finishLoading');
    });
  },

  newSignWorkflow(context, params) {
    store.dispatch('application/startLoading');
    return api.newSignWorkflow(params.workflow, params.files).then(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: i18n.t('signworkflows.messages.create.success'),
      });
      context.dispatch('updateCreationState', false);
    }).catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: i18n.t('signworkflows.messages.create.error'),
      });
      return Promise.reject(error);
    });
  },

  /**
   * check if the signature code is correct
   * @param {any} params contains the userId and the input code
   */
  checkSignatureCode(context, params) {
    store.dispatch('application/startLoading');
    return api.checkSignatureCode(params)
      .then(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('signworkflow.signatureFrame.validCode'),
        });
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('signworkflow.signatureFrame.invalideCode'),
        });
      });
  },

  /**
   * Send the request to get a signature code reminder
   * @param {any} params contains userId, media, and details(amil, pone number)
   */
  sendSignatureCodeReminder(context, params) {
    store.dispatch('application/startLoading');
    return api.sendSignatureCodeReminder(params)
      .then(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('signworkflow.forgottenCode.request.success'),
        });
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('signworkflow.forgottenCode.request.failure'),
        });
      });
  },

  updateSignWorkflow(signWorkflow) {
    return api.updateSignWorkflow(signWorkflow);
  },

  deleteSignWorkflow(context, id) {
    store.dispatch('application/startLoading');
    return api.deleteSignWorkflow(id)
      .then(store.dispatch('application/finishLoading'));
  },

  updateCreationState(context, value) {
    context.commit(types.UPDATE_CREATION_STATE, value);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/signWorkflow/actions.js